<template>
  <div>
    <v-navigation-drawer
      app
      clipped
      v-model="drawer"
      :mini-variant.sync="minimize"
      color="#35495e"
      permanent
      class="my-navigation-drawer"
      src="../assets/bg.jpg"
    >
      <v-list>
        <div style="height: 56px">
          <v-list-item>
            <v-list-item-icon>
              <v-icon @click="minimize = !minimize" color="white">
                mdi-menu
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </div>
        <v-divider class="my-divider" />
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.path"
          link
          @click.stop="onClickStop"
        >
          <v-list-item-icon class="mr-5">
            <v-icon color="white" :title="$t(item.title)">{{
              item.icon
            }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              class="white--text font-weight-bold text-uppercase pt-1"
              style="font-size: 13px !important"
            >
              {{ $t(item.title) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      clipped-left
      color="white darken-3"
      dark
      class="my-app-bar"
      :class="minimize ? 'l-56' : 'l-256'"
    >
      <router-link to="/" :title="$t('systemName')" @click.stop="onClickStop">
        <img class="logo" src="../assets/logo.png" :alt="$t('systemName')" />
      </router-link>
      <router-link to="/" :title="$t('systemName')" @click.stop="onClickStop">
        <v-toolbar-title class="toolBarTitle align-center">
          <span class="title text-subtitle-1 text-md-h5 ml-2 system-title">
            {{ $t("systemName") }}
          </span>
        </v-toolbar-title>
      </router-link>
      <v-spacer />
      <v-menu
        :value="option.value"
        :disabled="option.disabled"
        :absolute="option.absolute"
        :open-on-hover="option.openOnHover"
        :close-on-click="option.closeOnClick"
        :close-on-content-click="option.closeOnContentClick"
        :offset-x="option.offsetX"
        :offset-y="option.offsetY"
        :nudge-bottom="option.nudgeBottom"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            outlined
            color="secondary"
            dark
            v-on="on"
            class="ml-auto mb-1 d-flex white"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on"
                  >mdi-account</v-icon
                >
              </template>
              <span> {{ jwt.getName() }} </span>
            </v-tooltip>
            <v-divider class="mx-4 primary" vertical />
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div class="mr-2 text-display" v-bind="attrs" v-on="on">
                  {{ jwt.getName() }}
                </div>
              </template>
              <span>{{ jwt.getName() }}</span>
            </v-tooltip>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-if="allowChangePass" @click="changePassword()">
            <v-list-item-title>{{
              $t("navBars.changePassword")
            }}</v-list-item-title>
          </v-list-item>
          <v-divider v-if="allowChangePass" />
          <v-list-item class="logout" @click="logOut">
            <v-list-item-title>{{ $t("navBars.signOut") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import JwtService from "@/common/jwt.service";
import { PURGE_AUTH } from "@/store/mutations.type";
import { ROLE_ENUMS, MENU_HOME } from "@/common/auth.const";
import { LOGOUT } from "@/api/auth";

export default {
  name: "NavBar",
  props: {
    source: String,
  },
  computed: {
    allowChangePass() {
      return this.jwt.isAdmin();
    },
  },
  data: () => ({
    drawer: true,
    minimize: true,
    items: MENU_HOME.filter((item) =>
      item.authorities.includes(JwtService.getRole()),
    ),
    option: {
      value: false,
      disabled: false,
      absolute: false,
      openOnHover: false,
      closeOnClick: true,
      closeOnContentClick: true,
      offsetX: false,
      offsetY: true,
      nudgeBottom: 7,
    },
    jwt: JwtService,
    rolesEnum: ROLE_ENUMS,
  }),
  methods: {
    async logOut() {
      try {
        await LOGOUT();
        this.$store.commit(PURGE_AUTH);
        window.location.href = "/login";
      } catch (e) {}
    },
    changePassword: function () {
      this.$router.push("/reset-password");
    },
    onClickStop() {
      this.drawer = false;
      this.minimize = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.nav-divider-color {
  background-color: #2196f3 !important;
  border-color: #2196f3 !important;
}
</style>
<style lang="scss">
.v-navigation-drawer.my-navigation-drawer {
  top: 0 !important;
  max-height: calc(100%) !important;

  .logo {
    height: 35px !important;
  }

  .my-divider {
    background-color: #ffffff;
    border-color: transparent;
    margin: 0 auto;
    width: 95%;
  }

  .v-navigation-drawer__image {
    opacity: 20% !important;
  }

  .collapse-expand {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
.logout {
  cursor: pointer;
}
.v-toolbar.my-app-bar {
  box-shadow: 0 0 2.25rem #9da5ab !important;
  border-bottom: solid 1px #e5e5e5 !important;
  .logo {
    margin-top: 3px;
    height: 50px !important;
  }

  a {
    text-decoration: none !important;
  }

  .system-title {
    font-weight: 800;
    font-size: 40px;
    letter-spacing: 5px !important;
    color: #000;
  }
}

.v-toolbar.my-app-bar.l-256 {
  left: 256px !important;
}

.v-toolbar.my-app-bar.l-56 {
  left: 56px !important;
}

@media only screen and (max-width: 800px) {
  .toolBarTitle {
    display: none;
  }
}
</style>
